import React from "react";
import "../landing.css";
import youtubeLight from "../../../asset/ces/ces-icon-btn_youtube-light.png";
import youtubeDark from "../../../asset/ces/ces-icon-btn_youtube-dark.png";
import newsLight from "../../../asset/ces/ces-icon-btn_page-light.png";
import newsDark from "../../../asset/ces/ces-icon-btn_page-dark.png";
import youtubeLightHover from "../../../asset/ces/ces-icon-btn_youtube-light-hover.png";
import youtubeLightActive from "../../../asset/ces/ces-icon-btn_youtube-light-active.png";
import youtubeDarkHover from "../../../asset/ces/ces-icon-btn_youtube-dark-hover.png";
import youtubeDarkActive from "../../../asset/ces/ces-icon-btn_youtube-dark-active.png";
import newsLightHover from "../../../asset/ces/ces-icon-btn_page-light-hover.png";
import newsLightActive from "../../../asset/ces/ces-icon-btn_page-light-active.png";
import newsDarkHover from "../../../asset/ces/ces-icon-btn_page-dark-hover.png";
import newsDarkActive from "../../../asset/ces/ces-icon-btn_page-dark-active.png";
import mindsNaviImg from "../../../asset/ces/ces-btn_MindsNAVI.png";
import mindsNaviImgHover from "../../../asset/ces/ces-btn_MindsNAVI-hover.png";
import mindsNaviImgActive from "../../../asset/ces/ces-btn_MindsNAVI-active.png";
import cheeuForestImg from "../../../asset/ces/ces-btn_CHEEUForest.png";
import cheeuForestImgHover from "../../../asset/ces/ces-btn_CHEEUForest-hover.png";
import cheeuForestImgActive from "../../../asset/ces/ces-btn_CHEEUForest-active.png";
import styled from "styled-components";

const Icon = styled.img`
  width: 48px;
  height: 48px;
  cursor: pointer;

  &[src="${youtubeLight}"] {
    content: url(${youtubeLight});
    &:hover {
      content: url(${youtubeLightHover});
    }
    &:active {
      content: url(${youtubeLightActive});
    }
  }

  &[src="${newsLight}"] {
    content: url(${newsLight});
    &:hover {
      content: url(${newsLightHover});
    }
    &:active {
      content: url(${newsLightActive});
    }
  }

  &[src="${youtubeDark}"] {
    content: url(${youtubeDark});
    &:hover {
      content: url(${youtubeDarkHover});
    }
    &:active {
      content: url(${youtubeDarkActive});
    }
  }

  &[src="${newsDark}"] {
    content: url(${newsDark});
    &:hover {
      content: url(${newsDarkHover});
    }
    &:active {
      content: url(${newsDarkActive});
    }
  }
`;

const ProductImage = styled.img`
  cursor: pointer;

  &[src="${mindsNaviImg}"] {
    content: url(${mindsNaviImg});
    &:hover {
      content: url(${mindsNaviImgHover});
    }
    &:active {
      content: url(${mindsNaviImgActive});
    }
  }

  &[src="${cheeuForestImg}"] {
    content: url(${cheeuForestImg});
    &:hover {
      content: url(${cheeuForestImgHover});
    }
    &:active {
      content: url(${cheeuForestImgActive});
    }
  }
`;

const Product = () => {
  React.useEffect(() => {
    // 모든 이미지 프리로드
    const images = [
      youtubeLight,
      youtubeLightHover,
      youtubeLightActive,
      youtubeDark,
      youtubeDarkHover,
      youtubeDarkActive,
      newsLight,
      newsLightHover,
      newsLightActive,
      newsDark,
      newsDarkHover,
      newsDarkActive,
      mindsNaviImg,
      mindsNaviImgHover,
      mindsNaviImgActive,
      cheeuForestImg,
      cheeuForestImgHover,
      cheeuForestImgActive,
    ];

    images.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  return (
    <div className="landing-section-product">
      <h1 className="product-section-title">Products</h1>
      <div className="product-container">
        <ProductItem
          productName="MindsNAVI"
          title="Depression screening accuracy"
          descriptions={["Sensitivity : 97.2%", "Specificity : 95.2%"]}
          youtubeLink="https://youtu.be/OZXRgWfZ738?si=g7oXmSZf-jUTnExe"
          newsLink="https://pmc.ncbi.nlm.nih.gov/articles/PMC10990624/pdf/pi-2023-0253.pdf"
          imgPath={mindsNaviImg}
          onClick={() => {
            const pdfUrl = "/ces/pdf/Minds_NAVI.pdf";
            const pdfWindow = window.open(pdfUrl, "_blank");
            if (pdfWindow) {
              pdfWindow.focus();
            }
          }}
        />
        <ProductItem
          productName="CHEEUForest"
          title="Depression Treatment Efficacy"
          descriptions={[
            "Suicide risk : 54% reduction",
            "Depressive symptoms : 48% reduction",
          ]}
          youtubeLink="https://youtu.be/bKsUaDGvDEU?si=OW5zN9r5DCqW5so0"
          newsLink="https://www.eymj.org/Synapse/Data/PDFData/0069YMJ/ymj-65-e78.pdf"
          imgPath={cheeuForestImg}
          onClick={() => {
            const pdfUrl = "/ces/pdf/CHEEU_Forest.pdf";
            const pdfWindow = window.open(pdfUrl, "_blank");
            if (pdfWindow) {
              pdfWindow.focus();
            }
          }}
        />
      </div>
    </div>
  );
};

const ProductItem = ({
  productName,
  title,
  descriptions,
  youtubeLink,
  newsLink,
  imgPath,
  onClick,
}) => {
  const youtubeIcon = productName === "MindsNAVI" ? youtubeLight : youtubeDark;
  const newsIcon = productName === "MindsNAVI" ? newsLight : newsDark;

  const handleLinkClick = (e) => {
    e.stopPropagation(); // 이벤트 버블링 방지
  };

  return (
    <div
      className="product-item"
      onClick={onClick}
      style={{ cursor: "pointer" }}
    >
      {imgPath && (
        <ProductImage
          src={imgPath}
          alt={productName}
          className="product-item-image"
        />
      )}

      {title && <h3 className="product-item-title">{title}</h3>}
      <div style={{ height: "60px" }}>
        {descriptions && descriptions.length > 0 && (
          <div className="product-item-descriptions">
            {descriptions.map((desc, index) => (
              <p key={index} className="product-item-description">
                • {desc}
              </p>
            ))}
          </div>
        )}
      </div>
      <div className="product-item-links" onClick={handleLinkClick}>
        {youtubeLink && (
          <a href={youtubeLink} target="_blank" rel="noopener noreferrer">
            <Icon src={youtubeIcon} alt="youtube" />
          </a>
        )}
        {newsLink && (
          <a href={newsLink} target="_blank" rel="noopener noreferrer">
            <Icon src={newsIcon} alt="news" />
          </a>
        )}
      </div>
    </div>
  );
};

export default Product;
